import styled from 'styled-components';

import { RecipeAddToCart } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/components/RecipeAddToCart/RecipeAddToCart';
import { RecipeNameAndTags } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/components/RecipeNameAndTags/RecipeNameAndTags';
import { RecipePreparationInfos } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/components/RecipePreparationInfos/RecipePreparationInfos';
import { RecipeShortDescription } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/components/RecipeShortDescription/RecipeShortDescription';
import { media } from '~/src/styles-constants';

export enum RecipeGridArea {
  AddToCart = 'add-to-cart',
  Image = 'image',
  NameAndTags = 'name-and-tags',
  PreparationInfos = 'preparation-infos',
  ShortDescription = 'short-description',
}

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  gap: 16px;
  padding-top: 16px;
  padding-bottom: 40px;
  margin: 0 5px;

  ${media.M`
    margin: auto;
    gap: 8px;
    padding-bottom: 88px;
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 1024px;
  margin: 0 auto;
  width: 100%;
`;

export const Image = styled.img`
  grid-area: ${RecipeGridArea.Image};
  width: 100%;
  max-width: 369px;
  border-radius: 16px;
  margin: auto;
`;

export const SectionName = styled.h2`
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  margin: 0 0 8px;
`;

export const NameAndTags = styled(RecipeNameAndTags)`
  grid-area: ${RecipeGridArea.NameAndTags};
`;

export const PreparationInfos = styled(RecipePreparationInfos)`
  grid-area: ${RecipeGridArea.PreparationInfos};
`;

export const AddToCart = styled(RecipeAddToCart)`
  grid-area: ${RecipeGridArea.AddToCart};
`;

export const ShortDescription = styled(RecipeShortDescription)`
  grid-area: ${RecipeGridArea.ShortDescription};
`;

export const IngredientsAndEssentials = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  ${media.M`
    gap: 24px;
  `}
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  grid-template-areas:
    '${RecipeGridArea.NameAndTags}'
    '${RecipeGridArea.Image}'
    '${RecipeGridArea.PreparationInfos}';

  &:has(${ShortDescription}) {
    grid-template-areas:
      '${RecipeGridArea.NameAndTags}'
      '${RecipeGridArea.Image}'
      '${RecipeGridArea.PreparationInfos}'
      '${RecipeGridArea.ShortDescription}';
  }

  ${media.M`
    grid-column-gap: 40px;
    grid-template-columns: 1fr 406px;

    grid-template-areas:
    '${RecipeGridArea.Image} ${RecipeGridArea.NameAndTags}'
    '${RecipeGridArea.Image} ${RecipeGridArea.AddToCart}'
    '${RecipeGridArea.Image} ${RecipeGridArea.PreparationInfos}';

    &:has(${ShortDescription}) {
      grid-template-areas:
      '${RecipeGridArea.Image} ${RecipeGridArea.NameAndTags}'
      '${RecipeGridArea.Image} ${RecipeGridArea.AddToCart}'
      '${RecipeGridArea.Image} ${RecipeGridArea.PreparationInfos}'
      '${RecipeGridArea.Image} ${RecipeGridArea.ShortDescription}'
    }

    grid-template-columns: 369px 1fr;
    grid-column-gap: 40px;
  `}

  ${media.L`
    grid-column-gap: 88px;
  `};
`;
